import { createContext, } from 'react';
export const defaultContext = {
    border: false,
    onChange: () => { },
    pickerName: 'iconpicker',
    selectedValue: undefined,
    size: 'medium',
};
export const IconPickerContext = createContext(defaultContext);
